import { styled, Typography, type CSSObject } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';

export const StyledSection = styled(Section)(({ theme }) => ({
  padding: theme.spacing(12, 0),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(8, 0),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(6, 0),
  },
}));

export const StyledStack = styled('div')(({}) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const StyledContentWrapper = styled('div')(({}) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '660px',
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  marginBottom: theme.spacing(8),
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
    alignSelf: 'center',
    marginBottom: theme.spacing(4),
  },
}));

export const StyledSubTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.PRIMARY,
  marginBottom: theme.spacing(1),
}));

export const StyledDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.SECONDARY,
}));
